// extracted by mini-css-extract-plugin
export default {"root":"details_root__j+uzY","label":"details_label__J-qHx","toggleIcon":"details_toggleIcon__WRiUE","icon":"details_icon__IjIzR","error":"details_error__yG2pe"};